<script>

export default {
  components: {
  },
  data() {
    return {
      selected: "single",
    }
  },
  methods: {
    openModal() {
      this.$bvModal.show("modal-confirm-regular-update");
    },
    closeModal() {
      this.$bvModal.hide("modal-confirm-regular-update");
    },
    submit() {
      this.$emit("submit", this.selected);
      this.closeModal()
    },
  }
}
</script>
<template>
  <div class="d-xl-flex">
    <!-- modal area -->
    <b-modal
      id="modal-confirm-regular-update"
      centered
      hide-footer
      title="以下の定期予約スケジュールを変更します。"
    >
      <b-form-group v-slot="{ ariaDescribedby }">
        <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" value="single">選択したスケジュールのみ</b-form-radio>
        <b-form-radio v-model="selected" :aria-describedby="ariaDescribedby" value="all">これ以降の全ての定期スケジュール</b-form-radio>
      </b-form-group>
      <div class="d-flex justify-content-center gap-4">
        <b-button variant="primary" @click="submit">変更</b-button>
        <b-button variant="primary" @click="closeModal"><i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}</b-button>
      </div>
    </b-modal>
  </div>
</template>


<style scoped>

</style>
